module.exports = __webpack_public_path__ + "img/zhan4.957ceb82.png";